export namespace Enums {

    export enum ServiceProviderType { MSP = 1, Enterprise = 2 }
    export enum NoOfTechnicians { JustMe = 1, TwotoFour = 2, FivetoNine = 3, tentoNineteen = 4, tweentyPlus = 5 }

    export enum OTPChannel
    {
        sms = 1,
        email = 2
    }

    export enum HowDidYouHearAboutUs {
        Reddit = 1,
        MspCommunity = 2,
        Recommendation = 3,
        Google = 4,
        AiAssistant = 5,
        YouTube = 6,
        Podcast = 7,
        ReviewSite = 8,
        LinkedIn = 9,
        Facebook = 10,
        Instagram = 11,
        EventOrConference = 12,
        Partner = 13,
        Other = 14,
    }

    export enum Region {
        UsWest = 1,
        Australia = 2,
    }
    
    export enum RegionSlug {
        UsWest = "usw",
        Australia = "aue",
    }
}
